import { render, staticRenderFns } from "./TwoFaSendSmsDialog.vue?vue&type=template&id=4ff67f06&scoped=true"
import script from "./TwoFaSendSmsDialog.vue?vue&type=script&lang=js"
export * from "./TwoFaSendSmsDialog.vue?vue&type=script&lang=js"
import style0 from "./TwoFaSendSmsDialog.vue?vue&type=style&index=0&id=4ff67f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff67f06",
  null
  
)

export default component.exports